import { Component } from '@angular/core';
import { CreateBundleInfoComponent } from "../../../../../components/admin-dashboard-component/promotions/bundles-managment/create-bundle-component/create-bundle-info-component/create-bundle-info-component";
import { CreateBundleComponent } from "../../../../../components/admin-dashboard-component/promotions/bundles-managment/create-bundle-component/create-bundle-component";

@Component({
  selector: 'app-create-bundle-page',
  standalone: true,
  imports: [ CreateBundleComponent],
  templateUrl: './create-bundle-page.html',
  styleUrl: './create-bundle-page.scss'
})
export class CreateBundlePage {

}
